import { Status } from '../models/status.interfaces';

export const SilverMedallionBannerStatusMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'SILVER MEDALLION®',
    level: '0',
    name: 'silver'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const SilverMedallionBannerStatusWithLifetimeMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '',
    subtitle: '',
    level: '0',
    name: 'silver'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const SilverMedallionBannerWithSkyPriorityStatusMocks: Status = {
  priority: {
    label: 'SKY PRIORITY',
    url: '/us/en/check-in-security/sky-priority',
    active: true
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'SILVER MEDALLION®',
    level: '0',
    name: 'silver'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const SilverMedallionBannerWithSkyPriorityAndLifetimeStatusMocks: Status =
  {
    priority: {
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority',
      active: true
    },
    tier: {
      title: '',
      subtitle: '',
      level: '0',
      name: 'silver'
    },
    enrollDate: 'SKYMILES MEMBER SINCE 2004'
  };
